

// export default VerificationModal;
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useAuth } from "./useAuth";
import "./VerificationModal.css"; // Ensure this import is correct

const VerificationModal = ({ token, onVerified }) => {
  const { logout } = useAuth();
  const hasRun = useRef(false);
  const [message] = useState("Verifying your email...");

  useEffect(() => {
    const verifyUser = async () => {
      if (hasRun.current) return;
      hasRun.current = true;

      await logout();
      const role = localStorage.getItem("verificationRole");

      const verifyUrl =
        role === "admin"
          ? `${process.env.REACT_APP_BACKEND_URL}/admin/verify-email`
          : role === "student"
          ? `${process.env.REACT_APP_BACKEND_URL}/student/verify-email`
          : `${process.env.REACT_APP_BACKEND_URL}/auth/verify-email`;


      try {
        await new Promise((r) => setTimeout(r, 1500));

       const response = await fetch(verifyUrl, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ token }),
  credentials: "include",
});


        const data = await response.json();
        await logout();

        if (response.ok) {
          toast.success("Email verified successfully! Please login.");
        } else if (
          response.status === 400 ||
          data?.message?.includes("expired") ||
          data?.message?.includes("already")
        ) {
          toast.info("Link expired or already verified. Please login.");
        } else {
          toast.error("Verification failed. Please try again.");
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong.");
      } finally {
  const role = localStorage.getItem("verificationRole");

  localStorage.removeItem("verificationRole");
  localStorage.removeItem("verificationEmail");

  if (role === "admin") {
    window.location.href = `/Admin/login/${process.env.REACT_APP_ADMIN_PATH}/en-list/admin`;
  } else {
    onVerified(); // existing user login flow
  }
}

    };

    verifyUser();
  }, [token, logout, onVerified]);

  return (
    <div className="signup-modal-overlay">
      {/* Changed class name to avoid conflict with Signup.js */}
      <div className="status-modal-content">

        {/* ✅ Image Check: Use 'email-icon.png' if 'email-verified.png' is missing */}
        <img
          src="/image/email-verified.png" 
          alt="Email Verified"
          className="status-icon-img"
          onError={(e) => e.target.style.display = 'none'} // Hides if broken
        />

          <div className="mars-loader-wrapper-verify">
            <div className="mars-orbit-verify">
    
                <div class="loader-wrapper-verify">
                  <span class="loader-letter-verify">M</span>
                  <span class="loader-letter-verify">a</span>
                  <span class="loader-letter-verify">r</span>
                  <span class="loader-letter-verify">s</span>
                  <span class="loader-letter-verify">M</span>
                  <span class="loader-letter-verify">a</span>
                  <span class="loader-letter-verify">t</span>
                  <span class="loader-letter-verify">e</span>
                  

                  <div class="loader-verify"></div>
                </div>
            </div>

          </div>


        <h3 className="status-title">Email Verification</h3>

        <p className="status-text">{message}</p>

        <p className="status-footer-note">
          Hold Tight! We are securing your account...
        </p>

      </div>
    </div>
  );
};

export default VerificationModal;